import { useMutation, useQueryClient } from 'react-query';
import { useContext } from 'react';
import { FetchContext } from 'context/FetchContext';

function useDeletePodcastEpisode(podcastId) {
  const queryClient = useQueryClient();
  const { privateFetch } = useContext(FetchContext);

  return useMutation(
    async (episodeId) => {
      const res = await privateFetch.delete(`/v1/admin/podcast/${podcastId}/episode/${episodeId}`);
      return res.data;
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['podcast-episodes', podcastId]);
      },
      onError: (error) => {
        console.error('Failed to delete episode:', error);
      },
    }
  );
}

export default useDeletePodcastEpisode;
